export function buildSeoContext(knownIssues, seoScore, socialChecks) {
  const failedAudits = Object.values(knownIssues || {})
    .filter(
      (issue) =>
        issue?.category === "seo" &&
        issue?.score != null &&
        issue.score < 1 &&
        issue?.title,
    )
    .slice(0, 10)
    .map((issue) => ({
      title: issue.title,
      detail:
        issue.display ||
        issue.description ||
        (typeof issue.explanation === "string" ? issue.explanation : "") ||
        "",
    }))
    .map(({ title, detail }) => ({
      title,
      detail: String(detail).slice(0, 160),
    }));

  const socialMetaIssues = (socialChecks || [])
    .filter((check) => check?.status === "warn" || check?.status === "error")
    .slice(0, 8)
    .map(({ tag, status, message }) => ({
      tag: tag || "",
      status,
      message: String(message || "").slice(0, 160),
    }));

  return {
    seoScore: seoScore != null ? Math.round(seoScore) : null,
    failedAudits,
    socialMetaIssues,
  };
}

export function hasUsefulPageContext(pageContext) {
  if (!pageContext) return false;
  return !!(
    pageContext.documentTitle ||
    pageContext.h1 ||
    pageContext.headings?.length ||
    pageContext.paragraphs?.length ||
    pageContext.jsonLd?.name ||
    pageContext.jsonLd?.description
  );
}
